export const GENDER_INNCODE = {
  M: '0cc16321-5839-4cae-9fce-4321f38897e2',
  F: '11d3cd38-447c-455f-b1dc-e5f3a679c44e',
};
